export class UserPermissionsCommand {
    permission: string[];

    constructor(permissions: string[]) {
        this.permission = permissions;
    }
}
